<template>
    <v-navigation-drawer v-model="getMenu.show" :clipped="$vuetify.breakpoint.lgAndUp" app>
        <v-list dense class="leftSideMenuList">
            <template v-for="item in getMenu.items">
                <!-- <v-row v-if="item.heading" :key="item.heading" align="center">
                    <v-col cols="6">
                        <v-subheader v-if="item.heading">
                            {{ item.heading }}
                        </v-subheader>
                    </v-col>
                    <v-col cols="6" class="text-center">
                        <a href="#!" class="body-2 black--text">EDIT</a>
                    </v-col>
                </v-row> -->

                <v-list-group v-if="item.childs.length > 0" :key="item.link" v-model="item.model" :prepend-icon="icons[item.icon]" :append-icon="icons.mdiChevronDown">
                    <template v-slot:activator>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title>
                                    {{ item.title }}
                                </v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </template>
                    <v-list-item v-for="(child, i) in item.childs" :key="i" link :to="child.link">
                        <v-list-item-action v-if="child.icon">
                            <v-icon>{{icons[child.icon]}}</v-icon>
                        </v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>
                                {{ child.title }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-list-item>
                </v-list-group>
                <v-list-item v-else :key="item.link" link :to="item.link">
                    <v-list-item-action>
                        <v-icon>{{icons[item.icon]}}</v-icon>
                    </v-list-item-action>
                    <v-list-item-content>
                        <v-list-item-title>
                            {{ item.title }}
                        </v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </template>
        </v-list>
    </v-navigation-drawer>
</template>

<script>

    import {
        mdiHomeAssistant,
        mdiShape,
        mdiLayersTriple,
        mdiCart,
        mdiOffer,
        mdiBoomGate,
        mdiBoomGateDown,
        mdiBoomGateUp,
        mdiFaceProfile,
        mdiAccountStar,
        mdiAccountNetworkOutline,
        mdiFormatListText,
        mdiClipboardListOutline,
        mdiClipboardList,
        mdiChevronDown,
        mdiCartArrowRight,
        mdiCartOutline,
    } from '@mdi/js';

    export default {
        props: {
            source: String,
        },
        data: () => ({
			menu_show : true,
            dialog: false, 
			items: [],
			icons : {
				mdiHomeAssistant,
				mdiShape,
				mdiLayersTriple,
				mdiCart,
				mdiOffer,
				mdiBoomGate,
				mdiBoomGateDown,
				mdiBoomGateUp,
				mdiFaceProfile,
				mdiAccountStar,
				mdiAccountNetworkOutline,
				mdiFormatListText,
				mdiClipboardListOutline,
				mdiClipboardList,
				mdiChevronDown,
				mdiCartArrowRight,
				mdiCartOutline,
			}
		}),
		watch:{
			menu_show : function(n){
				if(this.getMenu.show != n){
					this.$store.dispatch("a_menuShowToggle")
				}
			},
			getMenu : function(n){ 
				if(n.show != this.menu_show){
					this.menu_show = n.show;
				}
			}
		},
		methods:{
			menuShowToggle(){
				this.$store.dispatch("a_menuShowToggle")
			}
		},
		computed:{
			getAuth(){
				return this.$store.getters.getAuth;
			},
			getMenu(){
				return this.$store.getters.getMenu;
			},
		}
    }
</script>

<style lang="less">
	.leftSideMenuList{
		.v-list-group{
			& > .v-list-item{
				.v-list-item{
					padding-left: 0px;
				}
			}
			& > .v-list-group__items{
				.v-list-item{
					padding-left:34px;
					.v-list-item__action{
						margin-right: 15px;
					}
				}
			}
		}
	}
</style>